import { useTranslation } from 'next-i18next';
import React from 'react';

export const ValSuccesso: React.FC<{
  onForward: () => void;
  isExternal?: boolean;
}> = ({ onForward, isExternal = false }) => {
  const { t } = useTranslation(['valutatore']);
  return (
    <div className="align-items-center">
      <div className="valutatore__title valutatore__title--success">
        {t('step_seven.title')}
      </div>
      <div
        className="valutatore__subtitle"
        dangerouslySetInnerHTML={{
          __html: t(
            isExternal ? 'step_seven.subtitle_ext' : 'step_seven.subtitle'
          ),
        }}
      ></div>
      <div className="valutatore__white_btn" onClick={() => onForward()}>
        {t('step_seven.cta')}
      </div>
    </div>
  );
};
